@if (direction === 'up') {
    <svg id="chevron-up-bold.svg" [attr.width]="width" [attr.height]="height" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M19.88 18.06L22 15.94L12 5.94L2 15.94L4.12 18.06L12 10.18L19.88 18.06Z" [attr.fill]="color" />
    </svg>
} @else {
    <svg id="chevron-down-bold.svg" [attr.width]="width" [attr.height]="height" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.88 5.94L22 8.06L12 18.06L2 8.06L4.12 5.94L12 13.82L19.88 5.94Z"
            [attr.fill]="color" />
    </svg>
}